import { memo, ReactNode } from 'react';

interface TableLabelProps {
  children: ReactNode;
}

function TableLabel({ children }: TableLabelProps) {
  return (
    <p className="px-[10px] py-[20px] text-[15px]">
      {children}
      <span className="text-[#FF0099] ml-[2px]">*</span>
    </p>
  );
}

export default memo(TableLabel);
